import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const groupItemCategoryApi = {
    getGroupItemCategoriesByGroupId: (groupId?: number): Observable<Dtos.GetGroupItemCategoriesByGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupItemCategoriesByGroupId = new Dtos.GetGroupItemCategoriesByGroupId();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.GetGroupItemCategoriesByGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}